import Vue, { CreateElement } from 'src/vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { WorkoutCardInfo } from '@src/components/card/workout-card/workout-card-info/workout-card-info'
import { Pagination } from '@src/elements/pagination/pagination'
import { DEFAULT_PAGE_SIZE } from '@src/util/constants'
import { NoteRow } from '@src/routes/members/components/notes/note-row'
import EventBus from '@src/lib/event_bus'

import './list.sass'

@Component
export class List extends Vue {

  @Prop({ required: false, default: false })
  styled: boolean

  @Prop({ required: true })
  items: Array<any>

  @Prop({ required: true })
  itemType: 'WorkoutCard' | 'Note'

  @Prop({ required: true, default: 1 })
  currentPage: number

  @Prop({ required: false })
  changePageCallback: (currentPage: number) => void

  private pageSize = DEFAULT_PAGE_SIZE
  private currentItems: Array<any>

  constructor (props) {
    super(props)
    this.currentItems = this.items
  }

  beforeUpdate () {
    this.currentItems = this.items
  }

  updated () {
    this.currentItems = this.items
  }

  // render only reads currentItems, so new items (e.g. the filtered notes) would not re-render the list
  @Watch('items')
  onItemsChanged () {
    this.currentItems = this.items
  }

  updateList (itemId) {
    let item = this.currentItems.find(function (item) {
      return item.id === itemId
    })
    item['state'] = 'trashed'
    let index = this.currentItems.indexOf(item)
    /* istanbul ignore else: the item was found in currentItems, so its index exists */
    if (item && index > -1) {
      this.currentItems.splice(index, 1)
    }
  }

  render (h: CreateElement) {
    let list = []

    switch (this.itemType) {
      case 'WorkoutCard':
        let nonCertifiedItems = this.currentItems
        if (this.currentItems.some(item => item.isCertified())) {
          nonCertifiedItems = this.currentItems.filter(item => !item.isCertified())
        }
        list = this.paginate(this.currentItems).map((item) => {
          return <WorkoutCardInfo type='view' workout={item} updateCallback={this.updateList} workoutCount={nonCertifiedItems.length} />
        })
        break
      case 'Note':
        list = this.paginate(this.currentItems).map((item) => {
          return <NoteRow checkup={null} note={item} key={item.id} removeCallback={() => EventBus.trigger('reloadNotes')}/>
        })
        break
      default:
        console.log('invalid item type: ', this.itemType)
    }

    return <div>
      <div class={`list paginated-list ${this.styled ? 'styled' : ''}`} ref='printContainer'>
        {list}
      </div>
      <Pagination changePage={this.changePageCallback}
                  currentPage={this.currentPage}
                  pageSize={this.pageSize}
                  total={this.currentItems.length} />
    </div>
  }

  private paginate (items) {
    let start = (this.currentPage - 1) * this.pageSize
    // when last page is empty go to prev page
    if (start === items.length && this.currentPage > 1) this.changePageCallback(this.currentPage - 1)
    return items.slice(start, start + this.pageSize)
  }

}
